/** ***********************************
EventBus class
*************************************/

/**
 * Create a new EventBus instance.
 */

function isNumber(va) {
  if (typeof va === 'undefined') return false;
  return Object.prototype.toString.call(va) === Object.prototype.toString.call(1);
}
function isFunction(va) {
  if (typeof va === 'undefined') return false;
  return Object.prototype.toString.call(va) === Object.prototype.toString.call(() => { });
}

function EventBus() {
  this.listeners = {};
  this.listenerId = 0;
}


/**
 * Add an event listener for a specified event
 */
EventBus.prototype.on = function (event, listener) {
  if (!(event in this.listeners)) {
    this.listeners[event] = [];
  }

  let lid = ++this.listenerId;

  this.listeners[event].push(lid, listener);

  return lid;
};


/**
 * Emit an event
 */
EventBus.prototype.emit = function (event, data, parms) {
  if (!(event in this.listeners)) return 0;

  for (let i = 0; i < this.listeners[event].length; i += 2) {
    this.listeners[event][i + 1](data, event, parms);
  }

  return this.listeners[event].length / 2;
};


/**
 * Remove an event listener for a specified event
 */
EventBus.prototype.remove = function (event, listener) {
  if (typeof event === 'undefined') {
    this.listeners = {};
    return 1;
  }

  if (!(event in this.listeners)) return 0;

  if (typeof listener === 'undefined') {
    delete this.listeners[event];
    return 1;
  }

  if (isNumber(listener)) {
    for (let i = 0; i < this.listeners[event].length; i += 2) {
      if (this.listeners[event][i] === listener) {
        this.listeners[event].splice(i, 2);
        return 1;
      }
    }

    return 0;
  } else if (isFunction(listener)) {
    for (let i = 0; i < this.listeners[event].length; i += 2) {
      if (this.listeners[event][i + 1] === listener) {
        this.listeners[event].splice(i, 2);
        return 1;
      }
    }

    return 0;
  }

  return 0;
};

const evbus = new EventBus();
window.evbus = evbus;

export default evbus;
